// The zones Back Office offers for the same field.
export const TIMEZONES = [
  'America/Anchorage',
  'America/Chicago',
  'America/Denver',
  'Pacific/Honolulu',
  'America/Los_Angeles',
  'America/New_York',
  'America/Phoenix',
]
